import React from 'react';
import { Button, Checkbox, Slider, Tooltip as AntdTooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { AnalyticsChartActions } from '../analytics_charts';
import DrawerOpenIcon from '../icons/DrawerOpenIcon';

const SupplierPerformanceToolbar = ({
	chartColor,
	minWoCount,
	setMinWoCount,
	showSupplierLabels,
	setShowSupplierLabels,
	suppliersPanelOpen,
	setSuppliersPanelOpen,
	clearAllFilters,
	hasActiveFilters,
	exportSupplierPerformanceCsv,
	comparison,
}) => {
	const sliderChip = (
		<div className="ml-3 box-border h-10 inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-[2px] border border-solid border-grey-5 bg-white px-3 print:!hidden">
			<AntdTooltip title="Filter suppliers by minimum number of completed work orders">
				<InfoCircleOutlined className="text-sm text-character-secondary" />
			</AntdTooltip>
			<span className="bodyregular shrink-0 text-grey-8">Minimum WOs completed:</span>
			<div className="flex shrink-0 items-center">
				<Slider
					min={0}
					max={1000}
					step={10}
					value={minWoCount}
					onChange={setMinWoCount}
					className="supplierPerformanceMinWoSlider !m-0 w-[100px] shrink-0"
					trackStyle={{ backgroundColor: chartColor }}
					handleStyle={{ borderColor: chartColor }}
				/>
			</div>
			<span className="footnoteregular min-w-8 shrink-0 whitespace-nowrap text-right leading-none text-grey-8">
				{minWoCount}
			</span>
		</div>
	);

	return (
		<div className="flex flex-wrap items-center justify-between gap-2 flex-1 h-10">
			<div className="flex flex-wrap items-center gap-2 h-full">
				{sliderChip}
				{hasActiveFilters && <Button size="large" onClick={clearAllFilters}>CLEAR FILTERS</Button>}
			</div>
			<div className="flex flex-wrap items-center gap-3 h-10 ">
				<Checkbox
					checked={showSupplierLabels}
					onChange={(event) => setShowSupplierLabels(event.target.checked)}
					className='!items-center flex [&>span>span]:-mt-1'
				>
					<span className="bodyregular text-character-primary">Supplier Labels</span>
				</Checkbox>
				<AnalyticsChartActions size="large" comparison={comparison} onDownload={exportSupplierPerformanceCsv} />
				<Button
				    size="large"
					className="!border-grey-5 !text-grey-8 hover:!border-grey-5 hover:!text-grey-8 focus:!border-grey-5 focus:!text-grey-8 active:!border-grey-5 active:!text-grey-8"
					onClick={() => setSuppliersPanelOpen(!suppliersPanelOpen)}
				>
					<span className="!inline-flex items-center gap-2">
						<span>SUPPLIERS</span>
						<DrawerOpenIcon />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default SupplierPerformanceToolbar;
